import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export function showQtButton(qticketUrl?: string): boolean {
  return qticketUrl !== undefined;
}

export function disableQtButtonStatus(
  qticketStatus?: PortalAdapterApi.QticketStatus
): boolean {
  if (qticketStatus === undefined) return true;
  return !qticketStatus.isAcceptable;
}

export default {
  showQtButton,
  disableQtButtonStatus,
};
